import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AGUAppSidebarComponent } from './components/app-sidebar/app-sidebar.component';
import { AGUIconComponent } from './components/icon/icon.component';
import { AGULogoComponent } from './components/logo/logo.component';
import { AGUPageBandComponent } from './components/page-band/page-band.component';
import { AGUFilterRailComponent } from './components/filter-rail/filter-rail.component';
import { AGURailFoldComponent } from './components/rail-fold/rail-fold.component';
import { AGUTabStripComponent } from './components/tab-strip/tab-strip.component';
import { AGUSortTriggerComponent } from './components/sort-trigger/sort-trigger.component';
import { AGUPlainHeaderComponent } from './components/plain-header/plain-header.component';
import { AGUSearchHeroComponent } from './components/search-hero/search-hero.component';
import { AGUItemCardComponent } from './components/item-card/item-card.component';
import { AGUPaginationComponent } from './components/pagination/pagination.component';
import { AGUSelectComponent } from './components/select/select.component';
import { AGUMultiSelectComponent } from './components/multi-select/multi-select.component';
import { AGUSegmentedComponent } from './components/segmented/segmented.component';
import { AGUScaleChoiceComponent } from './components/scale-choice/scale-choice.component';
import { AGUFileDropComponent } from './components/file-drop/file-drop.component';
import { AGUFadeDirective, AGURevealDirective, AGURiseDirective } from './motion/rise.directive';
import { AGUAppBarComponent } from './components/app-bar/app-bar.component';
import { AGUBottomTabsComponent } from './components/bottom-tabs/bottom-tabs.component';
import { AGUDrawerComponent } from './components/drawer/drawer.component';
import { AGUFilterSheetComponent } from './components/filter-sheet/filter-sheet.component';
import { AGUMobileChipsComponent } from './components/mobile-chips/mobile-chips.component';
import { AGUToastComponent } from './components/toast/toast.component';
import { AGUCrumbComponent } from './components/crumb/crumb.component';
import { AGUAdSlotComponent } from './components/ad-slot/ad-slot.component';
import { AGUStatePanelComponent } from './components/state-panel/state-panel.component';
import { AGUStateBannerComponent } from './components/state-panel/state-banner.component';
import { AGUSkeletonComponent } from './components/state-panel/skeleton.component';

const SHARED_DECLARATIONS = [
    AGURiseDirective,
    AGURevealDirective,
    AGUFadeDirective,
    AGUFileDropComponent,
    AGUScaleChoiceComponent,
    AGUAppSidebarComponent,
    AGUIconComponent,
    AGULogoComponent,
    AGUPlainHeaderComponent,
    AGUPageBandComponent,
    AGUFilterRailComponent,
    AGURailFoldComponent,
    AGUTabStripComponent,
    AGUSortTriggerComponent,
    AGUSearchHeroComponent,
    AGUItemCardComponent,
    AGUPaginationComponent,
    AGUSelectComponent,
    AGUMultiSelectComponent,
    AGUSegmentedComponent,
    AGUAppBarComponent,
    AGUBottomTabsComponent,
    AGUDrawerComponent,
    AGUFilterSheetComponent,
    AGUMobileChipsComponent,
    AGUToastComponent,
    AGUCrumbComponent,
    AGUAdSlotComponent,
    AGUStatePanelComponent,
    AGUStateBannerComponent,
    AGUSkeletonComponent,
] as const;

/**
 * The host-independent UI of the AGU app shell.
 *
 * A surface imports this alongside MJ's canonical components; the framework
 * classes (BaseAGUAppSurfaceComponent, the adapter, the composition parser) are
 * plain exports and need no module.
 *
 * Services in this package are explicitly NOT providedIn:'root' — a surface
 * provides its own adapter and readiness gate so two surfaces open at once keep
 * separate navigation state.
 */
@NgModule({
    declarations: [...SHARED_DECLARATIONS],
    imports: [CommonModule, FormsModule],
    exports: [...SHARED_DECLARATIONS],
})
export class AGUAppShellModule {}
